import React from 'react';
interface Achievement {
  image: string;
  title: string;
  subtitle?: string;
  featured?: boolean;
}
const achievements: Achievement[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/1z8sM5M2qkgoV4K6Esm7Hz/Akreditiran_fotograf_na_WRC_Croatia_2026.jpg',
  title: 'Akreditiran fotograf na WRC Croatia 2026',
  subtitle: 'Uradna akreditacija za svetovno prvenstvo v reliju',
  featured: true
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2SrmfAWRaJpSmnpK2f4cVS/Uradni_fotograf_v_ekipi_Jereb_racing_v_sezoni_2026.jpg',
  title: 'Uradni fotograf v ekipi Jereb racing v sezoni 2026'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/tXeKzizpaoDWSB9TAVkaJi/ponovno_avtor_slike_na_potni_knjigi_rallya_idrija_2025.jpg',
  title: 'Ponovno avtor slike na potni knjigi Rally Idrija 2025'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/i9fu6yNt3rKPzekt6ux6CK/Kolari_Vision_ambasador.jpg',
  title: 'Kolari Vision ambasador'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jrCCLxdn5jAL9yt8RaF7Lp/_MG_2702.jpg',
  title: 'Uradni fotograf Slovenskega dvojca Čendak&Markežič v sezoni 2025'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/3Lowc8tqS4JmEGFiAG6xfh/potna-knjiga-optimized.webp',
  title: 'Avtor naslovne slike potne knjige Rally Idrija 2024'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/uHiFdRuZ9eFjEzrRiFLnPf/prva-slo-rally-knjiga.webp',
  title: 'Avtor prve Slovenske rally foto knjige 2024',
  subtitle: 'M. Čendak in J. Markežič'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2SX7hfPZCUXRa3WSTjUbLm/35mesto.webp',
  title: '35. mesto od 1217 fotografov',
  subtitle: '(mednarodna udeležba) po presoji J. Polin slike leta 2023'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/wbPz27NuNXDGcQPTc1yAqX/studijska-fotografija.webp',
  title: 'Studijska fotografija'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jdxmR6iot8k2vKCJHJYVuP/drugi-utrinki.webp',
  title: 'Avtor še in še ujetih trenutkov svojega in tujega življenja'
}];
export function AchievementsSection() {
  const featuredAchievement = achievements[0];
  const proofAchievements = achievements.slice(1);
  return <section id="dosezki" className="bg-neutral-950 px-4 py-16 sm:px-6 sm:py-24 lg:px-8" data-id="element-22">
      <div className="mx-auto max-w-6xl" data-id="element-23">
        <div className="mb-10 sm:mb-14" data-id="element-24">
          <h2 className="text-2xl font-light text-white sm:text-3xl lg:text-4xl" data-id="element-25">
            Dosežki{' '}
            <span className="font-serif italic text-neutral-400" data-id="element-26">&</span>{' '}
            Priznanja
          </h2>
          <div className="mt-4 h-px w-24 bg-neutral-800" data-id="element-27" />
        </div>

        <article className="grid overflow-hidden border border-neutral-800 bg-neutral-900 lg:grid-cols-2" data-id="element-28">
          <img src={featuredAchievement.image} alt={featuredAchievement.title} className="aspect-[4/3] h-full w-full object-cover lg:aspect-auto lg:min-h-[22rem]" data-id="element-29" />
          <div className="flex flex-col justify-between p-7 sm:p-10 lg:p-12" data-id="element-30">
            <div data-id="element-31">
              <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-neutral-500" data-id="element-32">
                Aktualna prepoznavnost
              </p>
              <h3 className="mt-4 text-2xl font-light leading-tight text-white sm:text-3xl" data-id="element-33">
                {featuredAchievement.title}
              </h3>
              <p className="mt-5 max-w-lg text-sm font-light leading-relaxed text-neutral-400 sm:text-base" data-id="element-34">
                {featuredAchievement.subtitle}. Dostop do ekskluzivnih lokacij
                in priložnosti za dokumentiranje vrhunske avtomobilske akcije.
              </p>
            </div>

            <div className="mt-10 flex gap-8 border-t border-neutral-800 pt-5" data-id="element-35">
              <div data-id="element-36">
                <p className="text-[10px] uppercase tracking-widest text-neutral-600" data-id="element-37">
                  Vrsta
                </p>
                <p className="mt-1 text-xs text-neutral-300" data-id="element-38">
                  Rally fotografija
                </p>
              </div>
              <div data-id="element-39">
                <p className="text-[10px] uppercase tracking-widest text-neutral-600" data-id="element-40">
                  Leto
                </p>
                <p className="mt-1 text-xs text-neutral-300" data-id="element-41">2026</p>
              </div>
            </div>
          </div>
        </article>

        <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-4" data-id="element-42">
          {proofAchievements.map(item => <article key={item.title} className="overflow-hidden border border-neutral-800 bg-neutral-900" data-id="element-43">
              <img src={item.image} alt={item.title} className="aspect-[16/9] w-full object-cover" data-id="element-44" />
              <div className="p-5 sm:p-6" data-id="element-45">
                <h3 className="text-sm font-light leading-snug text-white" data-id="element-46">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs font-light leading-relaxed text-neutral-500" data-id="element-47">
                  {item.subtitle ?? getProofMeta(item.title)}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}
function getProofMeta(title: string) {
  const year = title.match(/20\d{2}/)?.[0];
  return year ? `Dokumentiran dosežek · ${year}` : 'Profesionalno fotografsko delo';
}